import React from 'react';
import { Box } from '@mui/material';

import FullScreenButton from '@components/FullScreenButton';
import LanguageButton from '@components/LanguageButton';
import UserAvatarButton from '@components/UserAvatarButton';
import DashboardLogoutButton from '../DashboardLogoutButton';

import BackButton from '@components/BackButton';
import AppLogo from '@components/AppLogo';

import { useStyles } from '@components/AppHeader/styles';
import { IAppHeader } from '@components/AppHeader/interfaces';

const DashboardAppHeader = ({
  isAuthorized = false,
  showUserAvatarButton = true,
  showLanguageButton = true,
  onBackClick,
}: IAppHeader) => {
  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      {onBackClick ? (
        <BackButton onClick={onBackClick} />
      ) : (
        <AppLogo />
      )}
      <Box sx={classes.actionsContainer}>
        <FullScreenButton />
        {isAuthorized ? (
          <>
            {showUserAvatarButton && <UserAvatarButton />}
            <DashboardLogoutButton />
          </>
        ) : (
          showLanguageButton && <LanguageButton />
        )}
      </Box>
    </Box>
  );
};

export default DashboardAppHeader; 